import { useEffect, useState } from 'react';
import { subscribeUpdate, applyUpdate } from '../services/pwaUpdate';
import './UpdateSnackbar.css';

// Snackbar M3: compare quando e' pronta una versione nuova dell'app.
// Di solito l'aggiornamento si applica da solo (vedi pwaUpdate.js); questo serve
// a chi resta a lungo nell'app aperta, ad esempio guardando un film.
export default function UpdateSnackbar() {
    const [available, setAvailable] = useState(false);
    const [dismissed, setDismissed] = useState(false);

    useEffect(() => subscribeUpdate(setAvailable), []);

    if (!available || dismissed) return null;

    return (
        <div className="update-snackbar" role="status" aria-live="polite">
            <span className="update-snackbar__text">Nuova versione disponibile</span>
            <button type="button" className="update-snackbar__action" onClick={applyUpdate}>
                Aggiorna
            </button>
            <button
                type="button"
                className="update-snackbar__close"
                onClick={() => setDismissed(true)}
                aria-label="Chiudi"
            >
                <span className="material-symbols-rounded">close</span>
            </button>
        </div>
    );
}
